import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalConstants } from "../common/global-constants";
import { BODiagnosticNovo } from "../models/BODiagnosticNovo.model";
import { BOTranspDiagnosticNovo } from "../models/auxiliars/BOTranspDiagnosticNovo.model";

@Injectable({
  providedIn: 'root'
}

)
export class DiagnosticNovoService{
    myAppUrl = GlobalConstants.apiURL;
    myApiUrl = 'api/DiagnosticNovo/';

    constructor(private http:HttpClient){}

    getAllByPatientId(patientId:number):Observable<BODiagnosticNovo[]>{
        return this.http.get<BODiagnosticNovo[]>(this.myAppUrl + this.myApiUrl+'getAllByPatientId/'+patientId);
    }

    getAllByPatientIdAndClinicId(patientId:number, clinicHistoryId:number):Observable<BODiagnosticNovo[]>{
        return this.http.get<BODiagnosticNovo[]>(this.myAppUrl + this.myApiUrl+'getAllByPatientIdAndClinicId/'+patientId +"/" + clinicHistoryId);
    }

    createOrUpdateDiagnosticNovo(transp:BOTranspDiagnosticNovo):Observable<BODiagnosticNovo[]>{
        const httpOptions = {
            headers: new HttpHeaders({'Content-Type': 'application/json'})
          }
          const body=JSON.stringify(transp);
          return this.http.post<BODiagnosticNovo[]>(this.myAppUrl + this.myApiUrl + 'createOrUpdateDiagnosticNovo',body,httpOptions);
    }

    deleteDiagnosticNovo(transp:BOTranspDiagnosticNovo):Observable<BODiagnosticNovo[]>{
                console.log("ENTRA AL SERVICE DeleteDiagnosticNovo, transp es:", transp);

        const httpOptions = {
            headers: new HttpHeaders({'Content-Type': 'application/json'})
          }
          const body=JSON.stringify(transp);
          return this.http.post<BODiagnosticNovo[]>(this.myAppUrl + this.myApiUrl + 'deleteDiagnosticNovo',body,httpOptions);
    }
//#region Single
  createOrUpdateDiagnosticSingle(patientId:number,
                                clinicHistoryId:number,
                                diagnostic:BODiagnosticNovo):Observable<BODiagnosticNovo>
  {
    const httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json'})
      }
      const body=JSON.stringify(diagnostic);
      return this.http.post<BODiagnosticNovo>(this.myAppUrl + this.myApiUrl + 'createOrUpdateDiagnosticSingle/' + patientId + '/' + clinicHistoryId,body,httpOptions);
  }

deleteDiagnosticSingle(id:number):Observable<BODiagnosticNovo>{
        const httpOptions = {
            headers: new HttpHeaders({'Content-Type': 'application/json'})
          }
          return this.http.post<BODiagnosticNovo>(this.myAppUrl + this.myApiUrl + 'deleteDiagnosticSingle/' + id,null,httpOptions);
    }


//#endregion Single


}
